import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { Box, makeStyles, Paper } from '@material-ui/core';
import { RouteBackground } from 'components';
import { CustomTheme } from 'common/ui/interfaces';
import { PageHeader } from 'common/components';
import messages from '../../messages';
import useRootSelector from 'common/hooks/useRootSelector';
import { selectIsUserLoggedIn } from 'modules/authentication/state/selectors';
import { selectIsMemberPortalUserLoggedIn } from 'memberPortalModules/authentication/state/selectors';
import CookiePolicy from 'modules/privacy-policy/components/CookiePolicy/CookiePolicy';

const useStyles = makeStyles((theme: CustomTheme) => ({
  paper: {
    padding: '16px',
  },
  header: {
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '16px',
    },
  },
  breadcrumbs: {
    color: theme.palette.text.secondary,
  },
}));

interface ICookiePolicyContainer {
  onBack?: () => void;
}

const CookiePolicyContainer: FC<ICookiePolicyContainer> = ({ onBack }) => {
  const intl = useIntl();
  const classes = useStyles();
  const isClientPortalUserLoggedIn: boolean = useRootSelector(selectIsUserLoggedIn);
  const isMemberPortalUserLoggedIn: boolean = useRootSelector(selectIsMemberPortalUserLoggedIn);
  const isUserLoggedIn = isClientPortalUserLoggedIn || isMemberPortalUserLoggedIn;

  return (
    <RouteBackground>
      <Box maxWidth="666px" margin={isUserLoggedIn ? 'none' : '0 auto'}>
        <PageHeader
          title={intl.formatMessage(messages.cookiesHowWeUseThem)}
          onBackButtonClick={onBack}
          className={classes.header}
          spacing={1}
        />

        <Paper className={classes.paper}>
          <CookiePolicy />
        </Paper>
      </Box>
    </RouteBackground>
  );
};

export default CookiePolicyContainer;
